export const DEFAULT_STORE_ID = '1';

export const DEFAULT_CHANNEL = 'LANDING';

export const PRODUCT_RULES = {
  title: 'Правила продажи товаров интернет-магазина Лемана ПРО для физических лиц',
  link: '/pravila/',
};

export const SERVICE_RULES = {
  title: 'Правила продажи услуг',
  link: '/pravila/uslugi/',
};
